/* eslint-disable react/prop-types */
import { useEffect } from 'react';

/**
 * Full page navigation to an allowed origin outside this app. React Router
 * cannot handle those, so the browser has to do it.
 */
const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
};

export default ExternalRedirect;
